/**
 * The single "Denker is disconnected" toast. Every disconnect and reconnect
 * message updates this id, so MAX_TOASTS eviction can never drop the
 * Reconnect action while newer toasts stack up.
 */
import { translate } from "@/i18n";
import { desktopConnectionHealthMessages } from "@/i18n/messages/desktop-connection-health";
import type { SystemToast } from "@/stores/notification-store";
import { clearConnectionToast, showConnectionToast } from "./connection-toast";

export const COMPANION_DISCONNECTED_TOAST_ID = "companion-disconnected";

export function showCompanionDisconnectToast(
  state: { level: SystemToast["level"]; description: () => string },
  onReconnect: () => void,
): void {
  showConnectionToast(
    () => ({
      id: COMPANION_DISCONNECTED_TOAST_ID,
      level: state.level,
      title: translate(
        desktopConnectionHealthMessages,
        "companionDisconnectedTitle",
      ),
      description: state.description(),
      actionLabel: translate(desktopConnectionHealthMessages, "reconnect"),
      persistent: true,
    }),
    onReconnect,
  );
}

export function clearCompanionDisconnectToast(): void {
  clearConnectionToast(COMPANION_DISCONNECTED_TOAST_ID);
}
